import {
  CollectionStore2,
  ConnectionHttpService,
  HttpApiCollectionRepository, ListStore2, ReadonlyHttpApiListRepository, ReadonlyRepositoryListStore2,
  RepositoryCollectionStore2,
  SOFTLINE_COLLECTION_REPOSITORY, SOFTLINE_LIST_REPOSITORY,
  Store2Builder,
  SubscriptionStore2
} from '@softline/core';
import { SOFTLINE_API_BEWEAU_ENTITIES } from '@softapps/feichtinger/goldschmiede';
import { Beweau } from '../types/beweau';
import { InjectionToken } from '@angular/core';

const beweauStore = new Store2Builder('beweau')
  .withProvider({
    provide: SOFTLINE_LIST_REPOSITORY,
    useFactory: (service: ConnectionHttpService) =>
      new ReadonlyHttpApiListRepository(service, SOFTLINE_API_BEWEAU_ENTITIES),
    deps: [ConnectionHttpService]
  })
  .withProvider({
    provide: SOFTLINE_COLLECTION_REPOSITORY,
    useFactory: (service: ConnectionHttpService) =>
      new HttpApiCollectionRepository(service, SOFTLINE_API_BEWEAU_ENTITIES),
    deps: [ConnectionHttpService]
  })
  .withSubFeature('list', ListStore2<Beweau>)
  .withSubFeature('subscription', SubscriptionStore2)
  .withSubFeature('remote', ReadonlyRepositoryListStore2<Beweau>)
  .withSubFeature('collection', CollectionStore2<Beweau>)
  .withSubFeature('collectionRemote', RepositoryCollectionStore2<Beweau>)

export const BeweauStore = new InjectionToken(
  'BeweauStore',
  {
    providedIn: 'root', factory: () => beweauStore.build()
  }
)
